<template>
    <g fill-rule="evenodd">
        <path d="M284.91 558c6.677 0 12.09 5.373 12.09 12s-5.413 12-12.09 12c-4.226 0-7.944-2.154-10.105-5.415-2.136 3.165-5.77 5.248-9.895 5.248-6.578 0-11.91-5.298-11.91-11.833s5.332-11.833 11.91-11.833c4.124 0 7.759 2.083 9.897 5.248 2.159-3.261 5.877-5.415 10.103-5.415zm-20 1.967c-5.568 0-10.098 4.5-10.098 10.033 0 5.532 4.53 10.033 10.098 10.033 5.567 0 10.097-4.501 10.097-10.033 0-5.532-4.53-10.033-10.097-10.033zm.756 5.533l3.875 9.167h-2.436l-.65-1.67h-3.903l-.651 1.67h-2.45l3.876-9.167h2.339zm20.726-.117h-4.765v9.133h4.779c2.004 0 3.034-1.05 3.034-2.563 0-1.311-.834-1.967-1.649-2.085l-.122-.014v-.055c.618-.068 1.51-.668 1.51-1.922 0-1.5-1.098-2.494-2.787-2.494zm-.343 5.316c.645 0 1.085.382 1.085.981 0 .586-.348.97-.986 1.018l-.14.005h-2.116v-2.004h2.157zm-21.546-2.654l-1.176 3.01h2.367l-1.19-3.01zm21.45-.85c.576 0 1.03.369 1.03.941 0 .573-.383.968-.982 1.018l-.131.005h-1.978v-1.963h2.06z" transform="translate(-253 -558)"/>
    </g>
</template>

<script>
export default {
    name: 'abIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 44 24');
    }
};
</script>
